
const getAuthToken = (): string => localStorage.getItem('jwtToken') ? `Bearer ${ localStorage.getItem('jwtToken')}` : '';

export type ErrorT = {
    hasError: boolean;
    message: string;
    status: number;
} | undefined;
const dbGet = async <T extends {}>(query: string, fetch = window.fetch): Promise<Response | ErrorT> => {
    let token;
    try {
        token = getAuthToken();
    }
    catch (e) {
        //
    }
    let q = query;
    let headers: {[key: string]: string} = {
        'Content-Type': 'application/json'
    };

    if (token) {
        q = `${q}/auth`;
        headers = {
            'Content-Type': 'application/json',
            Authorization: token
        };
    }
    const response = fetch(process.env.REACT_APP_API_URL + q,
        {
            method: 'GET',
            headers: headers
        }).catch(err => {

        return {
            status: 666,
            hasError: true,
            message: err
        };
    });

    return response;
};

export { dbGet };
